import { render, staticRenderFns } from "./add_Position.vue?vue&type=template&id=7bc57e92&scoped=true"
import script from "./add_Position.vue?vue&type=script&lang=js"
export * from "./add_Position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc57e92",
  null
  
)

export default component.exports